module.exports = __webpack_public_path__ + "static/media/info-24px.7d03c90c.svg";